(function (window, $j) {
    $j(document).ready(function () {
        var checkinForm = $j("#form-checkin");
        var msgLastName = checkinForm.find("#hdnLastName").val();
        var msgconfirmationNum = checkinForm.find("#hdnConfirmationNumber").val();

        //form validation and submit - uses jQuery validation plugin
        checkinForm.validate({
            submitHandler: function (form) {
                var lastName = $j(form).find("#checkinLastNameTxt").val();
                var confirmationNumber = $j(form).find("#checkinNumberTxt").val();
                var sslUrl = $j(form).find("button[type=submit]").data("href");
                var url = sslUrl.replace("{0}", lastName).replace("{1}", confirmationNumber);
                window.location.href = url;
            },
            rules: {
                "checkinLastNameTxt": "required",
                "checkinNumberTxt": "required"
            },
            messages: {
                "checkinLastNameTxt": msgLastName,
                "checkinNumberTxt": msgconfirmationNum
            }
        });
    });

})(window, $j);